module.exports = __webpack_public_path__ + "img/feedback-icon.a5f9fe31.png";